<template>
  <div>
    <div class="main_wrapper">
      <div v-if="activeTab === 0">
        <div class="box_grid_top">
          <div class="statusnav home_status_nav">
            <Nav :currentTab="childActiveTab.index" :navs="navs" @change="navsChange"></Nav>
          </div>
          <div class="topway">
            <div class="more" v-if="false">
              <div class="wangge">
                <div class="icon" :class="{ active: activeTab === 0 }" @click="activeTab = 0"></div>
              </div>
              <div class="liebiao">
                <div class="icon" :class="{ active: activeTab === 1 }" @click="activeTab = 1"></div>
              </div>
            </div>
          </div>
        </div>
        <project-grid :list="list"></project-grid>
      </div>
      <div v-if="activeTab === 1">
        <div class="box_list_top">
          <div class="search main_search_nav">
            <!--<div class="item">-->
            <!--<div class="title">平台类型:</div>-->
            <!--<div class="text">-->
            <!--<Nav :navs="platforms" @change="platformChange"></Nav>-->
            <!--</div>-->
            <!--</div>-->
            <div class="item">
              <div class="title">信息类型:</div>
              <div class="text">
                <Nav :navs="navs" @change="navsChange"></Nav>
              </div>
            </div>
            <div class="zhankai">
              <div class="split-line"></div>
              <div class="split-title" @click="zhankai">
                {{ zhankaiStatus ? "收起∧" : "更多∨" }}
              </div>
            </div>
            <div v-if="zhankaiStatus">
              <div class="item">
                <div class="title">发布时间:</div>
                <div class="text">
                  <Nav :navs="times" @change="timeChange"></Nav>
                </div>
                <div class="btn main_date" v-if="showDate">
                  <el-date-picker v-model="customDate" type="daterange" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                  <span v-if="false" @click="getList(1)">查询</span>
                </div>A
              </div>
              <div class="item main_input">
                <div class="title">项目名称:</div>
                <div class="text">
                  <el-input placeholder="请输入项目名称，支持模糊查询" v-model="query.name" clearable></el-input>
                </div>
                <div class="btn" @click="getList(1)"><span>查询</span></div>
              </div>
            </div>
          </div>
          <div class="way">
            <div class="more" v-if="false">
              <div class="wangge">
                <div class="icon" :class="{ active: activeTab === 0 }" @click="activeTab = 0"></div>
              </div>
              <div class="liebiao">
                <div class="icon" :class="{ active: activeTab === 1 }" @click="activeTab = 1"></div>
              </div>
            </div>
          </div>
        </div>
        <!--
      修改element样式在element-ui.css文件中修改
      main_list_table_th
      page2_list_table_th
      main_list_table
      -->
        <div class="list main_list_table_th page2_list_table_th">
          <div class="main_list_table">
            <el-table highlight-current-row @cell-click="handleCurrentChange" :data="list" style="width: 100%">
              <el-table-column prop="pjnoticetitle" label="名称"></el-table-column>
              <el-table-column prop="prsflgdesc" label="交易方式" align="center" width="150"></el-table-column>
              <el-table-column v-if="!query.pjnoticetype" label="倒计时" width="180">
                <template slot-scope="scope">
                  <!--v-if="scope.row.projectjkactualendtime"-->
                  <!--计划开始{{scope.row.prsbjbegtime}}==-->
                  <!--计划结束{{scope.row.prsbjendtime}}===-->
                  <!--实际开始{{scope.row.projectjkactualbegtime}}==-->
                  <!--实际结束{{scope.row.projectjkactualendtime}}===-->
                  <!--开始{{scope.row.bjbegtime}}==-->
                  <!--结束{{scope.row.bjendtime}}-->
                  <div v-if="+scope.row.btnstatus < 5 && scope.row.alertmsg">
                    <span>{{ scope.row.alertmsg }}</span>
                    <count-down v-if="
                      scope.row.btnstatus !== 5 && scope.row.btnstatusdesc
                    " :enddate="scope.row.enddate"></count-down>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="发布日期" align="center" width="150">
                <template slot-scope="scope">
                  <div v-if="!!query.pjnoticetype">
                    {{ scope.row.pjnoticetime | formatTime }}
                  </div>
                  <div v-else>{{ scope.row.projectggfbtime }}</div>
                </template>
              </el-table-column>
              <el-table-column label="进度/操作" width="130">
                <template slot-scope="scope">
                  <div style="display: flex; justify-content: center">
                    <div v-if="scope.row.btnstatus && scope.row.btnstatusdesc" class="list_btn" :class="{
                      being:
                        scope.row.btnstatus === 2 ||
                        scope.row.btnstatus === 4 ||
                        scope.row.btnstatus === 5,
                    }">
                      <div class="button">{{ scope.row.btnstatusdesc }}</div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="page">
            <page @pageChanged="pageChanged" :total="total" :currentPage="query.currentPage" :pageSize="pageSize">
            </page>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile_main_wrapper">
      <div>
        <div class="search">
          <div class="search_item">
            <div class="sarch_item_label">信息类型:</div>
            <div class="search_item_values">
              <Nav :navs="navs" @change="navsChange"></Nav>
            </div>
          </div>
          <div class="search_item" style="margin: 10px 0">
            <div class="sarch_item_label">发布时间:</div>
            <div class="search_item_values">
              <Nav :navs="times" @change="timeChange"></Nav>
              <div class="btn main_date" v-if="showDate">
                <el-date-picker v-model="customDate" type="daterange" range-separator="至" start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
                <span v-if="false" @click="getList(1)">查询</span>
              </div>
            </div>
          </div>
          <div class="search_item">
            <div class="sarch_item_label">项目名称:</div>
            <div class="search_item_values">
              <el-input placeholder="请输入项目名称，支持模糊查询" v-model="query.name" clearable></el-input>
              <div class="btn" @click="getList(1)"><span>查询</span></div>
            </div>
          </div>
        </div>

        <div class="list">
          <div class="list-page">
            <div class="list-page-item">
              <div class="item-cell item-title" style="width: 60%">名称</div>
              <div class="item-cell item-title" style="width: 20%">状态</div>
            </div>
            <div class="list-page-item" v-for="(item, index) in list" :key="index" @click="handleCurrentChange(item)">
              <div class="item-name item-cell">{{ item.pjnoticetitle }}</div>
              <div v-if="item.btnstatus && item.btnstatusdesc" class="list_btn item-state item-cell" :class="{
                being:
                  item.btnstatus === 2 ||
                  item.btnstatus === 4 ||
                  item.btnstatus === 5,
              }">
                <div class="button">{{ item.btnstatusdesc }}</div>
              </div>
            </div>
          </div>

          <div class="page">
            <page @pageChanged="pageChanged" :total="total" :currentPage="query.currentPage" :pageSize="pageSize">
            </page>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProjectGrid from "./ProjectGrid";
import CountDown from "./CountDown";
import Nav from "./Nav";
import Page from "./Page";
import dayjs from "dayjs";
import request from "@/utils/request";
// import _ from 'lodash'
export default {
  name: "homemain",
  components: { Nav, ProjectGrid, Page, CountDown },
  data() {
    return {
      navs: [],
      platforms: ["全部", "综合网站", "专属网站"],
      // 近一周   近一月  近三月  近半年  近一年
      // times: ['全部', '今天', '近三天', '近一周', '近一月', '近一年', '自定义'],
      times: [
        "全部",
        "近一周",
        "近一月",
        "近三月",
        "近半年",
        "近一年",
        "自定义",
      ],
      activeTab: 1,
      platformActiveTab: 0,
      timeActiveTab: 0,
      showDate: false,
      customDate: "",
      total: 0,
      pageSize: 9,
      query: {
        name: "",
        currentPage: 1,
        offset: 0,
      },
      list: [],
      model: {},
      nowdate: "",
      zhankaiStatus: true,
    };
  },
  filters: {
    formatTime(val) {
      return dayjs(val).format("YYYY-MM-DD");
    },
  },
  watch: {
    activeTab() {
      this.timeActiveTab = 0;
      this.platformActiveTab = 0;
      this.$store.commit("changeState", { searchinfo: "" });
      let index = this.navs.findIndex((v) => v.value === 0);
      if (index !== -1) {
        this.$store.commit("changeState", { childActiveTab: this.navs[1] });
      } else {
        this.$store.commit("changeState", { childActiveTab: this.navs[0] });
      }
      // if (this.activeTab === 0) {
      //   this.navs.splice(0, 1)
      // } else {
      //   this.navs.unshift({value: 1, label: '全部'})
      // }
    },
    platformActiveTab() {
      this.list = [];
      this.getList();
    },
    timeActiveTab() {
      this.customDate = "";
      this.list = [];
      this.getList();
    },
    childActiveTab() {
      this.list = [];
      this.getList();
    },
    searchinfo() {
      if (this.searchinfo) {
        this.activeTab = 1;
        this.query.name = this.searchinfo;
        this.list = [];
        this.getList();
      }
    },
  },
  mounted() { },
  created() {
    this.getNavs();
    this.getList();
    if (!this.query.pjnoticetype) {
      this.query.pjnoticetype = this.navs[0].value
    }
  },
  methods: {
    zhankai() {
      if (!this.zhankaiStatus) {
        this.zhankaiStatus = true;
      } else {
        this.zhankaiStatus = false;
      }
    },
    // todoo
    getNavs() {
      this.navs = [
        {
          index: 0,
          label: "采购公告",
          value: 6,
        },
        {
          index: 3,
          label: "成交公告",
          value: 60,
        },
        {
          index: 2,
          label: "澄清公告",
          value: 2,
        },
        {
          index: 4,
          label: "预成交公示",
          value: 5,
        },
      ];
      //   , {
      //   index: 6,
      //   label: '废标公告',
      //   value: 3
      // }, {
      //   index: 7,
      //   label: '终止公告',
      //   value: 4
      // }
    },
    handleCurrentChange(val) {
      this.model = val;
      // let obj = this.childActiveTab
      // obj.last = val
      // this.$store.commit('changeState', {'childActiveTab': obj})
      // let menu = this.menus[1]
      // this.$store.commit('changeState', {'parentActiveTab': menu})

      let { href } = this.$router.resolve({
        name: "pjnoticeInfo",
        query: { pjnoticeid: this.model.pjnoticeid, projectid: this.model.projectid },
      });
      window.open(href, "_blank");
    },
    navsChange(val, obj) {
      // console.log("=======", val, obj);

      this.query.pjnoticetype = obj.value;
      // console.log(val, obj, 'homemain二级菜单点击', this.childActiveTab)
      this.getList();
    },
    platformChange(val, index) {
      this.platformActiveTab = index;
      // console.log(val, index);
    },
    timeChange(val, index) {
      // console.log(val, index);
      this.timeActiveTab = index;
      if (index === 6) {
        this.showDate = true;
      } else {
        this.showDate = false;
      }
    },
    async getList(val) {
      if (val) {
        this.query.currentPage = 1;
      }
      if (this.query.name === "清空") {
        this.query.name = "";
      }
      this.query.platform = this.platformActiveTab;
      this.query.beginDate = "";
      this.query.endDate = "";
      // this.query.status = this.childActiveTab.index !== 0 ? this.childActiveTab.datawhere : ''
      this.nowdate = await request({
        method: "get",
        url: "xtgl/sysdata",
      });
      if (this.getDates.length > 0) {
        this.query.beginDate = this.getDates[0];
      }
      if (this.getDates.length === 2) {
        this.query.endDate = this.getDates[1];
      }
      this.$store.commit("changeState", { searchinfo: this.query.name });
      this.query.limit = this.query.limit ? this.query.limit : this.pageSize;
      this.query.cosid = this.cosId;
      this.list = [];
      this.query.selectField = `pjnoticetype, pjnoticetitle,prsflg,pjnoticetime,projectggfbtime,pjnoticetype,projecttime,prsbjendtime,prsbmendtime,
        prsbmbegtime,projectjkactualbegtime,projectjkactualendtime,projectisinvite,projectid,pjnoticeid,projectstatus,projectstopflg,projectcancelflg,prsbjbegtime`;
      let res = await request({
        url: "/web/web/getPageListForWeb",
        method: "get",
        params: this.query,
      });
      // if (this.childActiveTab.datafrom == '2') {
      //   // this.query.projectstatus = 60
      //   this.query.wmenuid = this.childActiveTab.value
      //   res = await request({
      //     method: 'get',
      //     url: '/web/web/getNoticePageList',
      //     params: this.query
      //   })
      // } else {
      //   res = await request({
      //     url: '/web/web/getPageListForWeb',
      //     method: 'get',
      //     params: this.query
      //   })
      // }
      this.list = res.list;
      // console.log("=======res.list=====", this.list);
      // console.log(this.list, 221111)
      this.total = res.count.length ? res.count[0].count : 0;
    },
    pageChanged(val) {
      this.query.currentPage = val.currentPage;
      this.query.limit = val.limit;
      this.query.offset = val.offset;
      this.getList();
    },
  },
  computed: {
    ...mapGetters([
      "menus",
      "parentActiveTab",
      "childActiveTab",
      "searchinfo",
      "cosId",
    ]),
    getDates() {
      let dates = [];
      if (this.timeActiveTab === 1) {
        // 近一周
        dates = [
          dayjs(this.nowdate).subtract(7, "day").format("YYYY-MM-DD"),
          dayjs(this.nowdate).format("YYYY-MM-DD"),
        ];
      } else if (this.timeActiveTab === 2) {
        // 近一月
        dates = [
          dayjs(this.nowdate).subtract(1, "month").format("YYYY-MM-DD"),
          dayjs(this.nowdate).format("YYYY-MM-DD"),
        ];
      } else if (this.timeActiveTab === 3) {
        // 近三月
        dates = [
          dayjs(this.nowdate).subtract(3, "month").format("YYYY-MM-DD"),
          dayjs(this.nowdate).format("YYYY-MM-DD"),
        ];
      } else if (this.timeActiveTab === 4) {
        // 近半年
        dates = [
          dayjs(this.nowdate).subtract(6, "month").format("YYYY-MM-DD"),
          dayjs(this.nowdate).format("YYYY-MM-DD"),
        ];
      } else if (this.timeActiveTab === 5) {
        // 近一年
        dates = [
          dayjs(this.nowdate).subtract(1, "year").format("YYYY-MM-DD"),
          dayjs(this.nowdate).format("YYYY-MM-DD"),
        ];
      } else if (
        this.timeActiveTab === 6 &&
        this.customDate &&
        this.customDate.length
      ) {
        dates = [
          dayjs(this.customDate[0]).format("YYYY-MM-DD"),
          dayjs(this.customDate[1]).format("YYYY-MM-DD"),
        ];
      } else {
        dates = [];
      }
      return dates;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../styles/variables.scss";

@media screen and (min-width: 1201px) {
  .mobile_main_wrapper {
    display: none;
  }

  .main_wrapper {
    .box_grid_top {
      padding: 0 20px;
      background-color: $color-bg-white;
      display: flex;

      .statusnav {
        padding: 35px 0 30px 0;
        flex: 1;
      }

      .topway {
        padding-top: 21px;
      }
    }

    .box_list_top {
      .search {
        background-color: $color-bg-white;
        padding: 29px 20px 0;

        .item {
          display: flex;
          align-items: center;
          padding-bottom: 29px;

          .title {
            padding-right: 40px;
            color: $color-text-secondary-gray;
          }

          .text {}

          .btn {
            flex: 1;
            display: flex;
            align-items: center;

            span {
              cursor: pointer;
              margin-left: 10px;
              padding: 8px 15px;
              color: #fff;
              background-color: $color-orange;
            }
          }
        }

        .zhankai {
          display: flex;
          align-items: center;
          padding: 0 0 15px;

          .split-line {
            /*border: solid 1px #eeeeee;*/
            width: 100%;

            border-bottom: 1px solid #d1dbe5;
            flex: 1;
          }

          .split-title {
            border: 1px solid #999999;
            border-radius: 1px;
            padding: 2px 5px;
            margin-left: 5px;
            font-weight: normal;
            font-size: $fontsize-medium-s;
            color: #999999;
            cursor: pointer;

            span {
              font-size: $fontsize-medium-s;
            }
          }
        }
      }

      .way {
        float: right;
        padding: 16px 0;
      }
    }

    .list {
      .page {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: $color-bg-white;
        padding: 18px 0;
      }

      .list_btn {
        cursor: pointer;
        color: #ffffff;
        display: flex;

        .button {
          text-align: center;
          width: 70px;
          padding: 2px 3px;
          background-color: $color-orange;
        }
      }

      .being {
        .button {
          background-color: $color-being-green;
        }
      }
    }

    .more {
      display: flex;

      .wangge {
        .icon {
          cursor: pointer;
          margin-left: 24px;
          width: 19px;
          height: 19px;
          background-size: 19px 19px;
          background-image: url("../../assets/img/icon_wangge.png");
        }

        div:hover {
          background-image: url("../../assets/img/icon_wangge_active.png");
        }

        .active {
          background-image: url("../../assets/img/icon_wangge_active.png");
        }
      }

      .liebiao {
        .icon {
          cursor: pointer;
          margin-left: 24px;
          width: 19px;
          height: 19px;
          background-size: 19px 19px;
          background-image: url("../../assets/img/icon_liebiao.png");
        }

        div:hover {
          background-image: url("../../assets/img/icon_liebiao_active.png");
        }

        .active {
          background-image: url("../../assets/img/icon_liebiao_active.png");
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .main_wrapper {
    display: none;
  }

  .mobile_main_wrapper {
    width: 100%;

    .search {
      .search_item {
        display: flex;
        align-items: center;

        .search_item_label {
          flex: 1;
        }

        .search_item_values {
          flex: 3;
          display: flex;
          flex-wrap: wrap;
          align-items: center;

          .el-input {
            width: 73%;
          }

          .btn {
            span {
              cursor: pointer;
              margin-left: 10px;
              padding: 8px 15px;
              color: #fff;
              background-color: $color-orange;
            }
          }
        }
      }
    }

    .list {
      .list-page {
        display: table;
        margin: 0 10px;

        .list-page-item {
          display: table-row;
          align-items: center;

          .item-cell {
            display: table-cell;
            vertical-align: middle;
            padding: 10px 0;
          }

          .item-name {
            width: 80%;
          }

          .item-state {
            width: 20%;
            text-align: center;
            cursor: pointer;
            margin-left: 10px;
            color: #fff;
          }

          .item-title {
            font-size: 18px;
            font-weight: bold;
            text-align: center;
          }

          .list_btn {
            color: #ffffff;

            .button {
              border-radius: 0.3em;
              text-align: center;
              padding: 2px 5px;
              background-color: $color-orange;
            }
          }

          .being {
            .button {
              border-radius: 0.3em;
              padding: 2px 5px;
              background-color: $color-being-green;
            }
          }
        }
      }

      .page {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: $color-bg-white;

        .el-pagination__jump {
          display: none !important;
        }
      }
    }
  }
}
</style>
